document.addEventListener('DOMContentLoaded', function () {
    const productDataElement = document.getElementById('product-data');
    if (!productDataElement) return;

    const cartCont = document.querySelector('.cart-count');
    const productData = JSON.parse(productDataElement.textContent);

    function getSelectedVariant() {
        // If product has only default variant, return it directly
        if (productData.hasOnlyDefaultVariant) {
            return productData.variants[0];
        }

        const selectedOptions = {};

        document.querySelectorAll('input[name^="product_option_"]:checked').forEach(function (input) {
            const position = input.dataset.optionPosition;
            const value = input.dataset.optionValue;
            selectedOptions[position] = value;
        });

        for (let variant of productData.variants) {
            let matches = true;

            if (selectedOptions[1] && variant.option1 !== selectedOptions[1]) matches = false;
            if (selectedOptions[2] && variant.option2 !== selectedOptions[2]) matches = false;
            if (selectedOptions[3] && variant.option3 !== selectedOptions[3]) matches = false;

            if (matches) return variant;
        }

        return null;
    }

    function showCartNotification(cartItem) {
        const notification = document.querySelector('.cart-notification');
        if (!notification) return;

        // Update notification content
        const image = notification.querySelector('.cart-notification-image img');
        const title = notification.querySelector('.cart-notification-product-title');
        const price = notification.querySelector('.cart-notification-product-price');
        const variantText = notification.querySelector('.cart-notification-variant');
        const qty = notification.querySelector('.cart-notification-qty span');

        if (image && cartItem.featured_image) {
            image.src = cartItem.featured_image.url;
            image.alt = cartItem.product_title;
        }
        if (title) title.textContent = cartItem.product_title;
        if (price) price.textContent = (cartItem.price / 100).toFixed(2);
        if (variantText) {
            variantText.textContent = cartItem.variant_title !== 'Default Title' ? cartItem.variant_title : '';
        }
        if (qty) qty.textContent = cartItem.quantity;

        // Show notification
        notification.classList.add('active');
    }

    function hideCartNotification() {
        const notification = document.querySelector('.cart-notification');
        if (notification) {
            notification.classList.remove('active');
        }
    }

    // Close notification
    const closeBtn = document.querySelector('.cart-notification-close');
    if (closeBtn) {
        closeBtn.addEventListener('click', hideCartNotification);
    }

    // Close on background click
    const notification = document.querySelector('.cart-notification');
    if (notification) {
        notification.addEventListener('click', function (e) {
            if (e.target === notification) {
                hideCartNotification();
            }
        });
    }

    // Quantity Selector
    const quantityInput = document.querySelector('[data-quantity-input]');
    const quantityDecrease = document.querySelector('[data-quantity-decrease]');
    const quantityIncrease = document.querySelector('[data-quantity-increase]');

    if (quantityDecrease && quantityInput) {
        quantityDecrease.addEventListener('click', function() {
            const currentValue = parseInt(quantityInput.value) || 1;
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
            }
        });
    }

    if (quantityIncrease && quantityInput) {
        quantityIncrease.addEventListener('click', function() {
            const currentValue = parseInt(quantityInput.value) || 1;
            quantityInput.value = currentValue + 1;
        });
    }

    if (quantityInput) {
        quantityInput.addEventListener('change', function() {
            const value = parseInt(this.value) || 1;
            if (value < 1) {
                this.value = 1;
            }
        });
    }

    const addToCartBtn = document.querySelectorAll('.add-to-cart-btn');
    const buyNowBtn = document.getElementById('buy-now-btn');

    if (addToCartBtn) {
        addToCartBtn.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const variant = getSelectedVariant();

                if (!variant) {
                    alert('Please select all options');
                    return;
                }

                if (!variant.available) {
                    alert('This variant is out of stock');
                    return;
                }

                const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: variant.id,
                        quantity: quantity
                    })
                })
                    .then(response => response.json())
                    .then(data => {
                        // Show cart notification instead of redirecting
                        showCartNotification(data);
                        fetch('/cart.js')
                            .then(response => response.json())
                            .then(data => {
                                cartCont.textContent = data.item_count;
                            })
                            .catch(error => {
                                console.error('Error fetching cart data:', error);
                            });
                    })
                    .catch(error => {
                        alert('Failed to add to cart');
                    });
            });
        });
    }

    if (buyNowBtn) {
        buyNowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const variant = getSelectedVariant();

            if (!variant) {
                alert('Please select all options');
                return;
            }

            if (!variant.available) {
                alert('This variant is out of stock');
                return;
            }

            const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: variant.id,
                    quantity: quantity
                })
            })
                .then(response => response.json())
                .then(data => {
                    window.location.href = '/checkout';
                })
                .catch(error => {
                    alert('Failed to add to cart');
                });
        });
    }

    // Notification buttons
    const checkoutBtn = notification?.querySelector('.cart-notification-buttons .primary-btn:first-child');
    const viewCartBtn = notification?.querySelector('.cart-notification-buttons .primary-btn:last-child');

    if (checkoutBtn) {
        checkoutBtn.addEventListener('click', function (e) {
            e.preventDefault();
            window.location.href = '/checkout';
        });
    }

    if (viewCartBtn) {
        viewCartBtn.addEventListener('click', function (e) {
            e.preventDefault();
            window.location.href = '/cart';
        });
    }
});
